import { domineNameReGex } from "../constants";

export const getCrossOrigin = (imagePath: string | undefined | null): "anonymous" | "use-credentials" | "" | undefined => {
  if (!imagePath) {
    return undefined;
  }

  if (imagePath.includes("amazon")) {
    return undefined;
  }

  return "";
};
